import { render } from "./document.vue?vue&type=template&id=773d48ce"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/document.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "773d48ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('773d48ce', __exports__)) {
    api.reload('773d48ce', __exports__)
  }
  
  module.hot.accept("./document.vue?vue&type=template&id=773d48ce", () => {
    api.rerender('773d48ce', render)
  })

}


export default __exports__